import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getDepotsColumns } from './tanStackColumns';

const DepotsTable = ({
  data,
  loading,
  totalRegistros,
  paginationState,
  setPaginationState,
  onRowClick,
  onEditar,
  onExcluir,
  onStatusClick,
}) => {
  const columns = getDepotsColumns(onEditar, onExcluir, onStatusClick);

  return (
    <Row>
      <Col md={12}>
        <TanStackTable
          enableExportExcel={true}
          enableColumnConfig={true}
          columnConfigKey="depots-listagem"
          columns={columns}
          data={data}
          onRowClick={(row) => {
            if (onRowClick) onRowClick(row);
          }}
          isSortable={true}
          withPagination={true}
          manualPagination={true}
          totalItems={totalRegistros}
          onPaginationChange={setPaginationState}
          controlledPagination={paginationState}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          initialState={{
            pageIndex: paginationState?.pageIndex || 0,
            pageSize: paginationState?.pageSize || 5,
          }}
          enableRowColors={true}
          loading={!!loading}
          className="mt-3"
        />
      </Col>
    </Row>
  );
};

export default DepotsTable;
